export type RhythmRun = { startedAt: string; status: string };
export type RhythmBucket = { day: string; label: string; succeeded: number; failed: number; unresolved: number };

const SUCCEEDED = new Set(["succeeded", "success", "completed"]);
const FAILED = new Set(["failed", "error"]);

/**
 * Seven calendar-day execution rhythm for one loop, ending today (UTC days).
 * Zero days are kept so time never compresses; running, queued, cancelled and unknown runs count as unresolved.
 */
export function buildRhythm(runs: RhythmRun[]): RhythmBucket[] {
  const today = new Date();
  today.setUTCHours(12, 0, 0, 0);
  const buckets: RhythmBucket[] = Array.from({ length: 7 }, (_, index) => {
    const date = new Date(today);
    date.setUTCDate(today.getUTCDate() - (6 - index));
    return { day: date.toISOString().slice(0, 10), label: date.toLocaleDateString(undefined, { weekday: "short", timeZone: "UTC" }), succeeded: 0, failed: 0, unresolved: 0 };
  });
  const byDay = new Map(buckets.map((bucket) => [bucket.day, bucket]));
  for (const run of runs) {
    const bucket = byDay.get(run.startedAt.slice(0, 10));
    if (!bucket) continue;
    const status = run.status.trim().toLowerCase();
    if (SUCCEEDED.has(status)) bucket.succeeded += 1;
    else if (FAILED.has(status)) bucket.failed += 1;
    else bucket.unresolved += 1;
  }
  return buckets;
}
